import _regenerator from "/var/jenkins_home/workspace/crm-admin-uat/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/crm-admin-uat/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import { getCustomerLabel } from '@/api/frontEndManagement/labelManagement';
export default {
  name: 'UserTagCom',
  props: {
    editData: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      userTagOpt: []
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, selectedTag;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return getCustomerLabel({
                enabled: true
              });
            case 1:
              res = _context.v;
              selectedTag = _this.editData.selectedTag;
              _this.userTagOpt = res.content.map(function (tag) {
                return {
                  id: tag.id,
                  label: tag.name,
                  setting: tag.setting,
                  children: tag.children,
                  selectedTag: selectedTag.map(function (item) {
                    if (item.categoryId === tag.id) {
                      return item.categoryId;
                    }
                  }).filter(function (el) {
                    return el;
                  })
                };
              });
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    closeUserTag: function closeUserTag() {
      this.$emit('close');
    },
    handleSubmit: function handleSubmit() {
      var userTagOpt = this.userTagOpt;
      var selectedTag = userTagOpt.map(function (main) {
        return main.selectedTag.map(function (seleted) {
          return main.children.map(function (chil) {
            if (seleted === chil.id) {
              return chil;
            }
          }).filter(function (item) {
            return item;
          });
        }).flat();
      }).flat();
      this.$emit('selectedTag', selectedTag);
    }
  }
};